const LOGO_URL =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_consulting-boost/artifacts/qllo1cw8_Monochrome%20on%20transparent.webp";

export function Logo({ variant = "dark", className = "" }) {
  // The source logo is a dark-grey monochrome on transparent background.
  // On dark surfaces we invert it to ivory using a CSS filter — no second asset needed.
  const isLight = variant === "light";
  const wordColor = isLight ? "#FAFAFA" : "#121212";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="logo">
      <img
        src={LOGO_URL}
        alt="EdRoy Consigliere"
        width={44}
        height={44}
        className="object-contain"
        style={{
          width: 44,
          height: 44,
          filter: isLight ? "brightness(0) invert(1)" : "brightness(0) invert(0.08)",
        }}
      />
      <div className="leading-tight">
        <div className="font-display text-[18px] tracking-tight" style={{ color: wordColor }}>
          EdRoy
        </div>
        <div
          className="font-mono uppercase"
          style={{ color: wordColor, fontSize: 9, letterSpacing: "0.28em" }}
        >
          Consigliere
        </div>
      </div>
    </div>
  );
}
